import React from 'react';
import { Select } from 'antd';
import useRequestHouses from '../../../../../../../queries/useRequestHouses';
import { useAddressDispatch, useHouseState, useStreetState } from '../../lib';
import { isInteger } from '../../../../../shared/lib/filterValidators';
import { changeHouse } from '../../model/actionTypes';
import { debounce } from '../../../../../../../helpers/debounce';
import { useSearchParams } from '../../../../../shared/lib/searchParams';
import { shutdownFiltersData } from '../../../../../shared/constants';
import { useMeasure } from '../../../../../../../hooks/useMeasure';
import TextWithTooltip from '../../../../../../../components/TextWithTooltip/TextWithTooltip';
import BlockWithExtraContent from '../../../../../../../components/BlockWithExtraContent/BlockWithExtraContent';

const {
  filters: { house: houseFilter, search },
  changeFilterDelay: delay,
} = shutdownFiltersData;

const OptionContent = ({ house }) => {
  const [ref, { width }] = useMeasure();

  return (
    <div ref={ref}>
      <TextWithTooltip
        parentWidth={width}
        mainTitle={[house.houseTypeName, house.name].filter(Boolean).join(' ')}
        render={({ textRef, ...props }) => (
          <BlockWithExtraContent
            {...props}
            ref={textRef}
            main={house.name}
            extra={house.houseTypeName}
          />
        )}
      />
    </div>
  );
};

const SelectHouse = ({ className }) => {
  const street = useStreetState();
  const house = useHouseState();
  const dispatch = useAddressDispatch();

  const [searchParams, setSearchParams] = useSearchParams();

  const { data: houses, isFetching } = useRequestHouses(Number(street), {
    staleTime: Infinity,
    enabled: isInteger(street),
  });

  const handleChange = (value) => {
    dispatch({ type: changeHouse, payload: value });

    debounce(() => {
      const newParams = new URLSearchParams(searchParams);

      Boolean(value?.trim())
        ? newParams.set(houseFilter.name, value.trim())
        : newParams.delete(houseFilter.name);

      newParams.delete(search.name);
      setSearchParams(newParams);
    }, delay)();
  };

  return (
    <Select
      className={className}
      loading={isFetching}
      allowClear={true}
      placeholder="Выберите дом"
      value={isFetching ? undefined : house}
      optionFilterProp="searchtext"
      showSearch
      optionLabelProp="label"
      onChange={handleChange}
      disabled={!isInteger(street)}
    >
      {houses?.map((house) => (
        <Select.Option
          key={house.id}
          searchtext={`${house.houseTypeName || ''}${house.name}`}
          label={house.name}
        >
          <OptionContent house={house} />
        </Select.Option>
      ))}
    </Select>
  );
};

export default SelectHouse;
